import { Toast } from 'vant'
import useClipboard from 'vue-clipboard3'
export default function useCopy() {

		 const { toClipboard } = useClipboard();
			 const copy = async (text) => {
			   try {
			     await toClipboard(text);
			 		Toast('复制成功!')
			   } catch (e) {
			     Toast('复制失败，请重试')
			   }
			 };



  return {
    copy
  }
}
